import { useState } from "react";
import SchemaJsonLd from "@/components/base/SchemaJsonLd";
import SectionHeading from "@/components/base/SectionHeading";

const faqs = [
  {
    q: "51cg网的内容多久更新一次？",
    a: "即时快讯与突发消息以滚动方式更新，重要进展通常在核实后几分钟内上线；今日速递每天早晚各整理一次，把当天值得留意的内容排好顺序。",
  },
  {
    q: "突发消息后续进展如何保证准确？",
    a: "突发事件初期信息往往不完整，我们会先给出已知事实，并标注为待核实；随后持续补充进展。如果早期表述与后续事实不符，会在文中更新说明。",
  },
  {
    q: "站内的爆料内容可以转载吗？",
    a: "欢迎在注明来源为 51cg网 并附上原文链接的前提下转载。涉及图片、视频等素材时，请一并保留来源说明，请勿做断章取义的二次剪辑。",
  },
  {
    q: "怎样才能第一时间收到今日速递？",
    a: "在页面中的订阅区域填写邮箱，并选择希望关注的栏目，即可在每天早晚收到速递邮件。订阅完全免费，也支持随时退订。",
  },
  {
    q: "如果发现内容与事实有出入怎么办？",
    a: "可以通过页面底部的联系邮箱与我们沟通，并附上具体条目与可核实的信息来源。核实后我们会尽快更正或补充说明，并在文末标注修改时间。",
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };

  return (
    <section aria-label="常见问题" className="mx-auto max-w-[1400px] px-4 md:px-6">
      <SchemaJsonLd data={schema} />
      <SectionHeading
        title="常见问题"
        subtitle="关于更新节奏、信息来源与订阅方式的常见疑问"
        icon="ri-question-answer-line"
      />
      <div className="grid grid-cols-1 gap-3 lg:grid-cols-2 lg:gap-4">
        {faqs.map((item, index) => {
          const isOpen = openIndex === index;
          return (
            <div
              key={item.q}
              className="h-fit overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                aria-expanded={isOpen}
                className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
              >
                <span className="flex items-start gap-3">
                  <span className="font-serif-cn text-sm font-bold text-primary-500">
                    Q{index + 1}
                  </span>
                  <span className="font-serif-cn text-sm font-semibold text-foreground-950 md:text-base">
                    {item.q}
                  </span>
                </span>
                <i
                  className={`shrink-0 text-xl text-foreground-500 transition ${
                    isOpen ? "ri-subtract-line" : "ri-add-line"
                  }`}
                />
              </button>
              <div
                className={`grid transition-all duration-300 ${
                  isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                }`}
              >
                <div className="overflow-hidden">
                  <p className="px-5 pb-5 pl-12 text-sm leading-relaxed text-foreground-600">
                    {item.a}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}